import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  min-height: 1.5rem;
  flex-wrap: wrap;
  gap: 0.75rem;
`;
